import { AxiosResponse } from 'axios';
import { put } from 'redux-saga/effects';
import { api } from '../../libs';
import { loginError } from '../actions/auth';
import {
  fetchFeedbackError,
  fetchFeedbackSuccess,
  IFeedbackFetchRequestAction,
} from '../actions/feedback';
import { IFeedback } from '../types/feedback';

export function* fetchFeedbackSaga(action: IFeedbackFetchRequestAction) {
  try {
    const response: AxiosResponse = yield api.feedback.getAllFeedback(action.payload);
    const fetchedFeedbackCollection: IFeedback[] = response.data.feedback;
    yield put(fetchFeedbackSuccess(fetchedFeedbackCollection, response.data.page_info));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(loginError(err.message));
    } else {
      yield put(fetchFeedbackError(err.message));
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/feedback.ts